import { render, staticRenderFns } from "./PreviousPage.vue?vue&type=template&id=0963bfdd"
import script from "./PreviousPage.vue?vue&type=script&lang=js"
export * from "./PreviousPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports